export default __webpack_public_path__ + "static/logo-da9b52b652992ee5cb44de5673062d5e.svg";